import React from 'react';
import { Box, Heading, Flex, Text, Divider } from 'theme-ui';
import EmailSignupForm from '~/components/Generic/EmailSignup/Form';
import useFooterQuery from '~/hooks/graphql/queries/use-footer';
import SocialLinks from '../Generic/SocialLinks';
import LinkRenderer from '../Generic/LinkRenderer';

export const Footer = ({ removeInsiderSignup }: { removeInsiderSignup: boolean }) => {
  const { pages, footerHeadline, footerDescription, footerEmailInputPlaceholder } = useFooterQuery();

  return (
    <Box
      as="footer"
      sx={{
        backgroundColor: 'black',
        color: 'white',
        px: ['2.4rem', null, '4rem'],
        pt: !removeInsiderSignup ? ['4.8rem', null, '8rem'] : ['2.4rem', null, '4rem'],
        pb: ['2.4rem', null, '4rem'],
        textAlign: 'center',
      }}
    >
      {!removeInsiderSignup && (
        <Flex
          sx={{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',

            mb: [0, null, '8rem'],
            '&::after': {
              content: "''",
              display: ['block', null, 'none'],
              mt: '4.8rem',
            },
          }}
        >
          <Heading
            as="h2"
            sx={{ textTransform: 'uppercase', mb: '1.6rem', fontSize: '2.8rem', p: { m: 0, lineHeight: 1 } }}
            dangerouslySetInnerHTML={{ __html: footerHeadline.childMarkdownRemark.html }}
          />

          <Text
            sx={{
              mb: '3.2rem',
              fontSize: ['1.4rem', null, '1.6rem'],
              fontWeight: 400,
              maxWidth: '36.6rem',
              lineHeight: 1,
            }}
          >
            {footerDescription}
          </Text>
          <EmailSignupForm
            isFooter={true}
            forwardSx={{ maxWidth: ['36.8rem', null, '46.8rem'] }}
            placement="footer"
            placeholder={footerEmailInputPlaceholder}
          />
        </Flex>
      )}

      <Flex sx={{ justifyContent: 'center', mb: '4.8rem' }}>
        {/* @ts-ignore */}
        <SocialLinks forwardSx={{ gridRow: ['auto', null, '1/2'], gridColumn: ['auto', null, '2/3'] }} />
      </Flex>
      <Divider sx={{ width: '100%', display: ['none', null, 'block'], mb: '2.4rem' }} color="UIGray3"></Divider>
      <Flex sx={{ justifyContent: 'space-between', alignItems: 'center', flexDirection: ['column', null, 'row'] }}>
        <Flex
          sx={{
            gap: ['2.4rem', null, '3.2rem'],
            gridRow: ['auto', null, '2/3'],
            flexDirection: ['column', null, 'row'],
            justifySelf: ['auto', null, 'start'],
            mb: ['4.8rem', null, 'inherit'],
          }}
        >
          {pages?.map((page) => {
            if (!page) return null;

            return (
              // @ts-ignore
              <LinkRenderer
                title={page.title}
                aria-label={page.title}
                page={page ?? {}}
                locationDetail="footer"
                key={page.id}
                slug={`${page.slug}`}
                sx={{ color: 'UIGray1', fontSize: '1.4rem', lineHeight: 1 }}
              >
                {page.title}
              </LinkRenderer>
            );
          })}
        </Flex>
        <Divider sx={{ width: '100%', display: ['initial', null, 'none'] }} color="UIGray3"></Divider>
        <Text
          aria-label="copyright"
          as="p"
          variant="small"
          sx={{
            mt: ['16px', null, 'inherit'],
            whiteSpace: 'nowrap',
            width: [null, 'fit-content'],
            fontSize: ['1.2rem'],
            gridRow: ['auto', null, '2/3'],
            gridColumn: ['auto', null, '3/4'],
            justifySelf: ['auto', null, 'end'],
          }}
        >
          &copy; {new Date().getFullYear()} OMORPHO
        </Text>
      </Flex>
    </Box>
  );
};

export default Footer;
